export default __webpack_public_path__ + "static/media/termo-Risco.ea063fbd.png";